"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = position;
function position(property, value) {
    if (property === "position" && value === "sticky") {
        return [
            "-webkit-sticky",
            "sticky"
        ];
    }
}
